import React from 'react';
import { EditableInfo } from '@icoach/components';
import { Divider, Typography } from "@curves/ui-base";
import clsx from 'clsx';

const XFactorNotesBox = ({ className, xFactorNotes: xFactorNotesProps, onEdit }) => {
    const xFactorNotes = xFactorNotesProps || [];
    return (
        <EditableInfo label="X-Factor 與運動目標" onEdit={onEdit} className={clsx(className, 'x-factor-box')} isMultiline>
            <Typography variant="body2" className="x-factor-box__title">
                動機與目的
            </Typography>
            <Typography>{xFactorNotes[0] || <span className={'font-color-4'}>未設定</span>}</Typography>
            <Divider className="my-2" />
            <Typography variant="body2" className="x-factor-box__title">
                運動目標
            </Typography>
            <Typography>{xFactorNotes[1] || <span className={'font-color-4'}>未設定</span>}</Typography>
        </EditableInfo>
    );
};

export default XFactorNotesBox;
